import { Controller } from "@hotwired/stimulus"
import { VisitHelper } from "~/helpers/visit_helper"

export default class extends Controller {
  static get values() {
    return { includeDisabledTracking: Boolean }
  }

  connect() {
    this.frames = ["campaigns_reporting_overview",
      "campaigns_reporting_graph",
      "campaigns_reporting_leaderboard",
      "campaign_reporting_details"]
  }

  applyDateRange({ detail: { startDate, endDate, range } }) {
    let params = {
      range: range,
      start_date: startDate,
      end_date: endDate
    }

    if (startDate && endDate) {
      let difference = (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)

      if (difference <= 15) {
        params["graph[by_period]"] = "day"
      } else if (difference <= 93) {
        params["graph[by_period]"] = "week"
      } else {
        params["graph[by_period]"] = "month"
      }
    }

    VisitHelper.update(this.frames, params)
  }

  toggleIncludeDisabledTracking() {
    this.includeDisabledTrackingValue = !this.includeDisabledTrackingValue
    VisitHelper.update(this.frames, { include_disabled_tracking: this.includeDisabledTrackingValue })
  }

  applyFilter({ detail: { name, values } }) {
    let params = {}
    params[name] = values.join("|")
    VisitHelper.update(this.frames, params)
  }
}
